import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppResource } from 'src/app/app.resource';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { HeaderVM } from 'src/app/shared/models/components/headerVm';
import { ConfirmQuoteVM } from 'src/app/shared/models/components/quoteconfirmation';
import { String } from 'typescript-string-operations';
import { State } from 'src/app/core/state/core.state';
import * as fromPath from '../../../core/state/path';
import * as fromOfferCustomization from '../../../core/state/offer-customization';
import * as fromTarification from '../../../core/state/tarification';
import * as fromDevis from '../../../core/state/devis';
import * as fromInfo from 'src/app/core/state/info';
import * as fromContext from 'src/app/core/state/context';
import { Store } from '@ngrx/store';
import { OfferCustomizationEnum } from 'src/app/shared/models/enum/offercustomization.enum';
import { lastValueFrom, take } from 'rxjs';
import {
  Devis,
  Formule,
  FormuleApi,
  MontantValeurObjets2000,
  SaisieFormule,
  SaisiePersonnalisation,
  Tarification
} from 'src/app/core/models/form-state.model';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { CurrencyPipe } from '@angular/common';
import { MatomoTracker } from 'ngx-matomo-client';
import { Stepper } from 'src/app/core/models/stepper.model';
import { Context } from 'src/app/core/models/context.model';
import { environment } from 'src/environments/environment';
import { VyVDevisDocumentType } from 'src/app/api/models/vyVDevisDocumentType';
import { AppConfig } from 'src/app/app.config';

export interface option {
  id: string;
  name: string;
  valueShow: string | null;
  value: number;
}

@Component({
  selector: 'app-quote-confirmation',
  templateUrl: './quote-confirmation.component.html',
  styleUrls: ['./quote-confirmation.component.scss']
})
export class QuoteConfirmationComponent extends BaseComponent implements OnInit {
  headerStep!: HeaderVM;
  text!: any;

  promo: boolean = false;
  codePromo: string = '';
  baseOption!: string;

  confirmQuoteVm!: ConfirmQuoteVM;
  options: option[] = [];

  iB_CP: boolean = false;
  iB_C: boolean = false;
  iB_P: boolean = false;
  iB_S: boolean = false;

  displayModal: boolean = false;
  disableNextStep: boolean = false;
  backgroundPanelPath!: string;
  textPanelPath!: string;
  path!: PathType;
  offer!: SaisieFormule;
  customization!: SaisiePersonnalisation;
  devis!: Devis;
  context!: Context;

  constructor(
    store: Store<State>,
    resources: AppResource,
    tracker: MatomoTracker,
    private router: Router,
    private currencyPipe: CurrencyPipe,
    @Inject(AppConfig) private appConfig: AppConfig
  ) {
    super(store, resources, tracker);

    this.headerStep = new HeaderVM(
      this.resource.header.stepQuote,
      2,
      this.resource.header.subStepConfirmation,
      10
    );
  }

  override async ngOnInit() {
    super.ngOnInit();

    await this.LoadVm();

    if (this.context && this.context.contextId) {
      await this.initRateBase();

      this.setOption();

      this.loadStateData();

      this.updateRate();
    }
  }

  get brand() {
    return this.appConfig.getConfig('brand');
  }

  async LoadVm() {
    this.devis = await lastValueFrom(this.store.select(fromDevis.selectDevisState).pipe(take(1)));
    this.context = await lastValueFrom(this.store.select(fromContext.selectContext).pipe(take(1)));

    if (this.devis.GDAPositif) {
      this.displayModal = true;
      this.disableNextStep = true;
    }
    if (
      this.devis &&
      !(
        this.context &&
        this.context.contextId &&
        this.context.contextData &&
        this.context.contextData.RefDevis
      )
    ) {
      this.confirmQuoteVm = new ConfirmQuoteVM(
        this.devis.NumeroDevis,
        String.format(this.resource.confirmquote.subtitle, this.devis.NumeroDevis),
        this.options,
        this.devis.RefDocumentDevis,
        this.devis.RefDocumentFIC,
        this.devis.RefDocumentInfo,
        this.devis.RefDocumentCG
      );
    } else if (
      this.context &&
      this.context.contextId &&
      this.context.contextData &&
      this.context.contextData.RefDevis
    ) {
      this.confirmQuoteVm = new ConfirmQuoteVM(
        this.context.contextData.RefDevis!,
        String.format(this.resource.confirmquote.subtitle, this.context.contextData.RefDevis),
        this.options,
        `${environment.apiRootUrl}/api/devis/${this.context.contextData.RefDevis}/documents/${VyVDevisDocumentType.DEVIS}?context=${this.context.contextId}&brand=${this.brand}`,
        `${environment.apiRootUrl}/api/devis/${this.context.contextData.RefDevis}/documents/${VyVDevisDocumentType.FIC}?context=${this.context.contextId}&brand=${this.brand}`,
        `${environment.apiRootUrl}/api/devis/${this.context.contextData.RefDevis}/documents/${VyVDevisDocumentType.IPID}?context=${this.context.contextId}&brand=${this.brand}`,
        `${environment.apiRootUrl}/api/devis/${this.context.contextData.RefDevis}/documents/${VyVDevisDocumentType.CG}?context=${this.context.contextId}&brand=${this.brand}`
      );
    }
  }

  async initRateBase() {
    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    this.offer = await lastValueFrom(
      this.store.select(fromOfferCustomization.selectSaisieFormule).pipe(take(1))
    );

    var offerState = await lastValueFrom(
      this.store.select(fromTarification.selectTarificationFormules).pipe(take(1))
    );

    this.customization = await lastValueFrom(
      this.store.select(fromOfferCustomization.selectSaisiePersonnalisation).pipe(take(1))
    );

    switch (this.path) {
      case PathType.HOUSING_PARIS:
        this.iB_P = true;
        break;
      case PathType.HOUSING:
        if (this.offer.FormuleSelectionnee == Formule.F1) this.iB_C = true;

        if (this.offer.FormuleSelectionnee == Formule.F2) this.iB_CP = true;
        break;
      case PathType.HOUSING_SOLIDARITY:
        this.iB_S = true;
        break;
      default:
        this.iB_CP = true;
        break;
    }

    if (this.offer.CodePromo != null && this.offer.CodePromo != '') {
      this.promo = true;
      this.codePromo = this.offer.CodePromo;
    }
  }

  setOption() {
    if (this.iB_CP) {
      if (this.promo)
        this.baseOption = String.format(
          this.resource.offercustomization.baseConfortPlusPromo,
          this.codePromo
        );
      else this.baseOption = this.resource.offercustomization.baseConfortPlus;
    } else if (this.iB_C) {
      if (this.promo)
        this.baseOption = String.format(
          this.resource.offercustomization.baseConfortPromo,
          this.codePromo
        );
      else this.baseOption = this.resource.offercustomization.baseConfort;
    } else if (this.iB_P) {
      if (this.promo)
        this.baseOption = String.format(
          this.resource.offercustomization.baseParisiennePromo,
          this.codePromo
        );
      else this.baseOption = this.resource.offercustomization.baseParisienne;
    } else if (this.iB_S) {
      if (this.promo)
        this.baseOption = String.format(
          this.resource.offercustomization.baseSolidairePromo,
          this.codePromo
        );
      else this.baseOption = this.resource.offercustomization.baseSolidaire;
    }

    this.options.push({
      id: OfferCustomizationEnum.Base,
      name: this.baseOption,
      valueShow: this.currencyPipe.transform(this.offer.Valeur),
      value: parseFloat(this.offer.Valeur)
    });
  }

  downloadDoc(uri: string) {
    window.open(uri, '_blank');
  }

  private loadStateData() {
    if (this.customization.MontantValeurObjets2000 != null) {
      switch (this.customization.MontantValeurObjets2000) {
        case MontantValeurObjets2000.Montant5000:
          if (this.iB_CP) {
            this.options.push({
              id: OfferCustomizationEnum.Object,
              name: this.resource.offercustomization.option5k,
              valueShow: this.resource.offercustomization.rateInclude,
              value: 0
            });
          }
          break;
        case MontantValeurObjets2000.Montant10000:
          this.options.push({
            id: OfferCustomizationEnum.Object,
            name: this.resource.offercustomization.option10k,
            valueShow: this.currencyPipe.transform(
              this.devis.PrimesOptions?.ObjetsValeur?.Valeur10000!
            ),
            value: this.devis.PrimesOptions?.ObjetsValeur?.Valeur10000!
          });
          break;
        case MontantValeurObjets2000.Montant20000:
          this.options.push({
            id: OfferCustomizationEnum.Object,
            name: this.resource.offercustomization.option20k,
            valueShow: this.currencyPipe.transform(
              this.devis.PrimesOptions?.ObjetsValeur?.Valeur15000!
            ),
            value: this.devis.PrimesOptions?.ObjetsValeur?.Valeur15000!
          });
          break;
      }
    } else {
      if (this.iB_CP) {
        this.options.push({
          id: OfferCustomizationEnum.Object,
          name: this.resource.offercustomization.option5k,
          valueShow: this.resource.offercustomization.rateInclude,
          value: 0
        });
      }
    }

    if (this.customization.ProtectionVelos) {
      this.options.push({
        id: OfferCustomizationEnum.BP,
        name: this.resource.offercustomization.optionBP,
        valueShow: this.currencyPipe.transform(this.devis.PrimesOptions?.ProtectionVelos!),
        value: this.devis.PrimesOptions?.ProtectionVelos!
      });
    }

    if (this.customization.ProtectionJuridique) {
      this.options.push({
        id: OfferCustomizationEnum.JP,
        name: this.resource.offercustomization.optionJP,
        valueShow: this.currencyPipe.transform(this.devis.PrimesOptions?.ProtectionJuridique),
        value: this.devis.PrimesOptions?.ProtectionJuridique!
      });
    }

    if (this.customization.ProtectionNomades) {
      this.options.push({
        id: OfferCustomizationEnum.NP,
        name: this.resource.offercustomization.optionNP,
        valueShow: this.currencyPipe.transform(this.devis.PrimesOptions?.ProtectionNomades!),
        value: this.devis.PrimesOptions?.ProtectionNomades!
      });
    }

    if (this.customization.AssuranceScolaire != undefined) {
      const count = this.customization.AssuranceScolaire.length;
      const value = this.getRateSchoolInsurance(count);
      if (count > 0) {
        this.options.push({
          id: OfferCustomizationEnum.SI,
          name: this.resource.offercustomization.optionSI,
          valueShow: this.currencyPipe.transform(value),
          value: value
        });
      }
    }
  }

  updateRate() {
    this.confirmQuoteVm.rateMonth = this.currencyPipe.transform(this.devis.PrimeMensuelle);
    this.confirmQuoteVm.rateYear = this.currencyPipe.transform(this.devis.PrimeAnnuelle);
  }

  getRateSchoolInsurance(i: number): number {
    if (i == 1) return this.devis.PrimesOptions?.AssuranceScolaire?.Enfant1!;
    else if (i == 2) return this.devis.PrimesOptions?.AssuranceScolaire?.Enfant2!;
    else if (i == 3) return this.devis.PrimesOptions?.AssuranceScolaire?.Enfant3!;
    else if (i >= 4) return this.devis.PrimesOptions?.AssuranceScolaire?.Enfant4Plus!;
    else return 0;
  }

  nextStep() {
    this.updateStepper();
    this.router.navigate(['/services']);
  }

  validGDA() {
    this.displayModal = false;
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    var tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.quote
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.confirmquote
    );

    if (subtitleS) {
      subtitleS.isValid = true;
      subtitleS.isActive = true;
    }

    let titleN = tmpStepper.contract.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.contract
    );

    let subtitleNS = titleN?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.services
    );

    if (subtitleNS) subtitleNS.isActive = true;

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }
}
